import { render } from "./MkMenu.vue?vue&type=template&id=19b74e81&scoped=true"
const script = {}

import "./MkMenu.vue?vue&type=style&index=0&id=19b74e81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b74e81"]])

export default __exports__